"use client";

import { useActionState } from "react";

import { AuthNotice } from "@/components/auth-notice";

import { forgotPassword, type ForgotState } from "./actions";

const mono = "font-paw-mono";
const label = `mb-2 block ${mono} text-[11px] tracking-[0.16em] text-(--paw-steel-faint)`;

export function ForgotPasswordForm() {
  const [state, formAction, pending] = useActionState<ForgotState, FormData>(
    forgotPassword,
    null,
  );

  if (state && "sent" in state) {
    return (
      <AuthNotice>
        If that email has an account, a reset link is on its way. Check your
        inbox.
      </AuthNotice>
    );
  }

  return (
    <form
      action={formAction}
      className="flex flex-col"
      style={{ maxWidth: "26rem", gap: "22px" }}
    >
      <div>
        <label htmlFor="email" className={label}>
          EMAIL
        </label>
        <input
          id="email"
          name="email"
          type="email"
          required
          autoFocus
          autoCapitalize="off"
          autoCorrect="off"
          spellCheck={false}
          autoComplete="email"
          placeholder="you@example.com"
          className="paw-field"
        />
      </div>

      {state?.error ? <AuthNotice tone="error">{state.error}</AuthNotice> : null}

      <button
        type="submit"
        disabled={pending}
        className="paw-btn w-full disabled:opacity-60"
        style={{ padding: "17px" }}
      >
        {pending ? "SENDING…" : "EMAIL RESET LINK"}
      </button>
    </form>
  );
}
